export const API_PATHS = {
  EVENTS: '/api/v1/events',
  EVENTS_BATCH_ACTIONS: '/api/v1/events/actions/batch',
  EVENTS_METRICS: '/api/v1/events/metrics',
  SPACES: '/api/v1/spaces',
  SPACES_SEARCH: '/api/v1/spaces/search',
  BUILDINGS: '/api/v1/buildings',
  COUNTRIES: '/api/v1/countries',
  REGIONS: '/api/v1/regions',
  PLANNER_ACCESS: '/api/v1/planner-access',
  PLANNER_BUILDING_ACCESS: '/api/v1/planners/building-access',
  PLANNERS_BY_BUILDING: '/api/v1/planners/by-building',
  EMPLOYEE_SEARCH: '/api/v1/employee/list',
  EMPLOYEE_PHOTO: '/api/v1/employee/employee',
  CONTENT_IMAGES: '/api/v1/content/images',
} as const;

export const API_HEADERS = {
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-Type',
  CORRELATION_ID: 'x-correlation-id',
  IF_MATCH: 'If-Match',
  ETAG: 'ETag',
} as const;

export const API_CONTENT_TYPES = {
  JSON: 'application/json',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
} as const;

export const API_TIMEOUT_MS = 30000;

export const EVENT_SCOPE_MY_EVENTS = 'my-events';
